function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 14C3.25 15.5188 4.48122 16.75 6 16.75H10C10.6904 16.75 11.25 17.3096 11.25 18C11.25 18.6904 10.6904 19.25 10 19.25H6C3.10051 19.25 0.75 16.8995 0.75 14V6C0.75 3.1005 3.10051 0.75 6 0.75H14C16.8995 0.75 19.25 3.10051 19.25 6V6.44444C19.25 7.1348 18.6904 7.69444 18 7.69444C17.3096 7.69444 16.75 7.1348 16.75 6.44444V6C16.75 4.48122 15.5188 3.25 14 3.25H6C4.48122 3.25 3.25 4.48122 3.25 6V14ZM24.8529 9.91382C25.3576 9.44278 25.3849 8.65179 24.9138 8.1471C24.4428 7.64241 23.6518 7.61514 23.1471 8.08618L17.5714 13.2901L14.8529 10.7528C14.3482 10.2818 13.5572 10.3091 13.0862 10.8138C12.6151 11.3185 12.6424 12.1094 13.1471 12.5805L16.7185 15.9138C17.1988 16.3621 17.9441 16.3621 18.4243 15.9138L24.8529 9.91382Z"
});

var SvgActivity = function SvgActivity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activity.8d18450f.svg";
export { ForwardRef as ReactComponent };